export default function subnavigation() {
    let currentSlide = 1;
    const sliderImageElements = document.querySelectorAll('[data-slider-image]');
    const sliderTextElements = document.querySelectorAll('[data-slider-text]');
    const previousButtonElement = document.querySelector('#subhero-navigation-button-prev');
    const nextButtonElement = document.querySelector('#subhero-navigation-button-next');

    if (
        sliderImageElements &&
        sliderTextElements &&
        sliderImageElements.length === sliderTextElements.length &&
        previousButtonElement &&
        nextButtonElement
    ) {
        nextButtonElement.addEventListener('click', () => {
            if (currentSlide < sliderImageElements.length - 1) {
                currentSlide++;
            } else {
                currentSlide = 0;
            }

            rotateSlide(currentSlide);
        });

        previousButtonElement.addEventListener('click', () => {
            if (currentSlide > 0) {
                currentSlide--;
            } else {
                currentSlide = sliderImageElements.length - 1;
            }

            rotateSlide(currentSlide);
        });
    }

    function rotateSlide(index) {
        if ((window.matchMedia('(max-width:639px)').matches)) {
            const navigationOffset = previousButtonElement.getBoundingClientRect().top + document.documentElement.scrollTop - 10;

            /* center on currently clicked */
            window.scrollTo({
                top: navigationOffset,
                behavior: 'smooth'
            });
        }

        sliderImageElements.forEach(element => {
            if (element.dataset.sliderImage) {
                if (parseInt(element.dataset.sliderImage) !== index) {
                    element.classList.remove('active');
                } else {
                    element.classList.add('active');
                }
            }
        });

        sliderTextElements.forEach(element => {
            if (element.dataset.sliderText) {
                if (parseInt(element.dataset.sliderText) !== index) {
                    element.classList.remove('active');
                } else {
                    element.classList.add('active');
                }
            }
        });
    }
}
